// src/api/auth.js
// Utility to manage auth token with activity-based expiration

const TOKEN_KEY = 'tracker_token';
const TOKEN_LAST_ACTIVITY_KEY = 'tracker_token_last_activity';
const USER_SITE_ID_KEY = 'tracker_user_site_id';
// Inactivity timeout in milliseconds (15 minutes = 900000 ms)
// You can adjust this value: 5 minutes = 300000, 10 minutes = 600000, 30 minutes = 1800000, etc.
const INACTIVITY_TIMEOUT = 600000; // 10 minutes

export function setToken(token, userSiteId = null) {
  sessionStorage.setItem(TOKEN_KEY, token);
  // Set last activity time to now
  sessionStorage.setItem(TOKEN_LAST_ACTIVITY_KEY, Date.now().toString());
  
  // Store user's assigned site if provided
  if (userSiteId) {
    sessionStorage.setItem(USER_SITE_ID_KEY, userSiteId.toString());
  }
}

export function getToken() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const lastActivity = sessionStorage.getItem(TOKEN_LAST_ACTIVITY_KEY);
  
  // Check if token exists and is not expired due to inactivity
  if (token && lastActivity) {
    const lastActivityTime = parseInt(lastActivity);
    const inactiveTime = Date.now() - lastActivityTime;
    
    if (inactiveTime > INACTIVITY_TIMEOUT) {
      // Token has expired due to inactivity, remove it
      console.log("Token expired due to inactivity");
      removeToken();
      return null;
    }
  }
  
  return token;
}

export function getUserSiteId() {
  return sessionStorage.getItem(USER_SITE_ID_KEY);
}

export function updateActivity() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) {
    // Update last activity time whenever user interacts with the site
    sessionStorage.setItem(TOKEN_LAST_ACTIVITY_KEY, Date.now().toString());
  }
}

export function isTokenExpired() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const lastActivity = sessionStorage.getItem(TOKEN_LAST_ACTIVITY_KEY);
  
  if (!token || !lastActivity) return true;
  
  const lastActivityTime = parseInt(lastActivity);
  const inactiveTime = Date.now() - lastActivityTime;
  
  return inactiveTime > INACTIVITY_TIMEOUT;
}

export function removeToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_LAST_ACTIVITY_KEY);
  sessionStorage.removeItem(USER_SITE_ID_KEY);
}
